import "./EliminationBanner.css";

export default function EliminationBanner(props) {
  return (
    <div className="banner banner-eliminated col" role="status">
      <h2 className="t-h2">Thank you for taking part.</h2>
      <p className="t-body t-dim">
        {props.teamName ? `${props.teamName}'s` : "Your team's"} journey in the
        Multipli Hackathon ends here. We are grateful for the work you put in,
        and we hope to see you at the next one.
      </p>
    </div>
  );
}
